import { Team } from '@/api';
import { ReactElement, ReactNode } from 'react';
import { TeamContext, TeamContextData } from './context';

type TeamProviderProps = {
    readonly team: Team;
    readonly children?: ReactNode;
};

export function TeamProvider({
    team,
    children
}: TeamProviderProps): ReactElement {
    const value: TeamContextData = {
        team
    };

    return (
        <TeamContext.Provider value={value}>{children}</TeamContext.Provider>
    );
}
